<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="entity-viewer" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <em-workflow-business-data-editor :entity="modelName"
                                                              :business-data="$_emWorkflowTaskMixin_businessData">
                            </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <div id="workflow-process_execution" class="content">
                <WorkflowProcessLine :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
                                     :config="processConfig"
                                     ref="processExecution" @gotItems="setLocalVariables"
                                     :businessKey="$_emWorkflowTaskMixin_businessKey">
                </WorkflowProcessLine>
            </div>

            <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">
                <WorkflowTaskComplete ref="processComplete"
                                      :task-id="$_emWorkflowTaskMixin_taskId"
                                      :businessKey="$_emWorkflowTaskMixin_businessKey"
                                      :status="$_emWorkflowTaskMixin_businessData.status"
                                      :callbackApi="$_emWorkflowTaskMixin_callbackApi"
                                      :config="processConfig">
                </WorkflowTaskComplete>
            </div>
        </section>
    </div>
</template>
<script>
// Author YuJiaBei
// Date 2021-11-30 10:49:34

import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";
import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine";
import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete";

export default {
    name: "repairWorkOrderWorkflowTaskView",
    components: {WorkflowProcessLine, WorkflowTaskComplete},
    mixins: [emWorkflowTaskMixin, workflowTaskMixins],
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        processConfig() {
            return {
                'task1': {
                    name: '维修工单',
                    variables: [
                        {
                            label: '提交类型',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '提交审核'},
                                {value: 2, text: '作废工单'}
                            ]
                        }
                    ],
                    withAttachment: true,
                    withComment: true
                },
                'task3': {
                    name: '维修中',
                    variables: [
                        {
                            label: '提交类型',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '提请验收'},
                                {value: 2, text: '维修退回'}
                            ],
                            changeTag: val => {
                                return this.buildTag('tj', val === 1)
                            }
                        },
                        {
                            label: '实际开始时间',
                            name: 'rwoActualStartDate',
                            type: this.VALUE_TYPE.DATETIME,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true,
                            needTag: 'tj'
                        },
                        {
                            label: '实际结束时间',
                            name: 'rwoActualFinishDate',
                            type: this.VALUE_TYPE.DATETIME,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true,
                            needTag: 'tj'
                        },
                        {
                            label: '维修工时（小时）',
                            name: 'rwoStandWorkhour',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true,
                            needTag: 'tj'
                        }
                    ],
                    userSelectMap: {
                        '1': [
                            {
                                name: 'rwoMainExecutor',
                                labelWithout: "执行负责人",
                                allowMulti: true,
                                // require: true,
                                saveToDatabase: true
                            },
                            {
                                name: 'rwoOtherExecutors',
                                labelWithout: "执行人",
                                allowMulti: true,
                                //require: true,
                                saveToDatabase: true
                            }
                        ]
                    },
                    withAttachment: true,
                    withComment: true
                },
                'task3_1': {
                    name: '重新维修中',
                    variables: [
                        {
                            label: '提交类型',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '提请验收'},
                                {value: 2, text: '维修退回'}
                            ],
                            changeTag: val => {
                                return this.buildTag('tj', val === 1)
                            }
                        },
                        {
                            label: '实际开始时间',
                            name: 'rwoActualStartDate',
                            type: this.VALUE_TYPE.DATETIME,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true,
                            needTag: 'tj'
                        },
                        {
                            label: '实际结束时间',
                            name: 'rwoActualFinishDate',
                            type: this.VALUE_TYPE.DATETIME,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true,
                            needTag: 'tj'
                        },
                        {
                            label: '维修工时（小时）',
                            name: 'rwoStandWorkhour',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true,
                            needTag: 'tj'
                        }
                    ],
                    userSelectMap: {
                        1: [{
                            name: 'rwoMainExecutor',
                            labelWithout: "执行负责人",
                            initData: true,
                            initDataName: 'rwoMainExecutor',
                            allowMulti: true,
                            //require: true,
                            saveToDatabase: true
                        },
                            {
                                name: 'rwoOtherExecutors',
                                labelWithout: "执行人",
                                initData: true,
                                initDataName: 'rwoOtherExecutors',
                                allowMulti: true,
                                //require: true,
                                saveToDatabase: true
                            }]
                    },
                    withAttachment: true,
                    withComment: true
                },
                '*': {
                    name: '维修工单',
                    variables: [
                        {
                            label: '提交类型',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '至下一任务'},
                                {value: 2, text: '驳回'}
                            ]
                        }
                    ],
                    withAttachment: true,
                    withComment: true
                }
            }
        }
    }
};
</script>